import { FilterSelectionState } from "@/filters/selection/FilterSelectionState";
import { SortingState } from "@/sorting/SortingState";
import { ISeoMetaDataInfo } from "../../ISeoMetaDataInfo";
import { SeoMetaDataHandler } from "../../SeoMetaDataHandler";
import { SortingOptions } from "@/sorting/SortingOptions";
import { AttendanceFilterOptionValue, FilterKey } from "@studyportals/search-filters";

export class AttendanceOnline extends SeoMetaDataHandler {
	
	public async canHandle(sortState: SortingState, filterSelectionState: FilterSelectionState): Promise<boolean> {
		const metaRankingSortSelected = await this.sortingOptionSelected(SortingOptions.UNIVERSITY_META_RANKING, sortState);
		const attendanceSelected = await this.singleSelectionFor(FilterKey.DELIVERY_METHOD, filterSelectionState);
		const attendance = this.getFilterOptionValueBy(FilterKey.DELIVERY_METHOD, filterSelectionState);

		return metaRankingSortSelected && attendanceSelected && attendance === AttendanceFilterOptionValue.ONLINE;
	}

	protected selfHandle(): Promise<ISeoMetaDataInfo> {
		const year = this.getCurrentYearForSeo();

		const seoInfo = {
			title: `Top Online Universities | SP Meta Ranking`,

			description:
				`Find the best online universities in ${year}. ` +
				`Our rankings compare online courses, accreditation, student support, and tuition costs to help you choose wisely. `
		};

		return Promise.resolve(seoInfo);
	}
}
